import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Helmet } from 'react-helmet';
import DataSetting from './../DataSetting';
import moment from "moment/moment";
import queryString from 'query-string';
import DatePicker from 'react-datepicker';
import NotificationSystem from 'react-notification-system';
import progressBar from '../../../utils/progressBar';
import Pagination from "react-js-pagination";
import api from "../../../utils/api";
import "react-datepicker/dist/react-datepicker.css";

class UserLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userLogList: {
                data: [],
                current_page: 1,
                total: 0,
                per_page: 20,
            },
            startDate: moment().startOf('day'),
            endDate: moment(),
            keyword: '',
            notification: {
                allowHTML: false,
            },
        }
    }

    notificationSystem = React.createRef();

    componentDidMount() {
        this.getUserLogs();
    }

    changeHandler = (dates) => {
        const hasStartDate = Object.prototype.hasOwnProperty.call(dates, 'startDate');
        const hasEndDate = Object.prototype.hasOwnProperty.call(dates, 'endDate');
        let { startDate, endDate } = dates;
        startDate = startDate || this.state.startDate;
        endDate = endDate || this.state.endDate;

        if (startDate !== null && startDate.isAfter(endDate)) {
            if (hasStartDate) {
                endDate = moment(startDate).endOf('day');
            }
            if (hasEndDate) {
                startDate = moment(endDate).startOf('day');
            }
        }

        this.setState({
            ...this.state,
            startDate,
            endDate,
        });
    };

    changeStartDateHandler = (startDate) => {
        this.changeHandler({
            startDate: startDate ? moment(startDate).startOf('day') : startDate,
        });
    };

    changeEndDateHandler = (endDate) => {
        this.changeHandler({
            endDate: endDate ? moment(endDate).endOf('day') : endDate,
        });
    };

    changeKeywordHandler = (event) => {
        this.setState({ keyword: event.target.value });
    };

    getUserLogs = (pageNumber = 1, perPage = null) => {
        let startDate = this.state.startDate ? this.state.startDate.format('YYYY-MM-DD HH:mm:ss') : null;
        let endDate = this.state.endDate ? this.state.endDate.format('YYYY-MM-DD HH:mm:ss') : null;
        const sceneCompanyId = this.props.sceneCompanyId || localStorage.getItem('sel_company_id') || '';
        const sceneLostId = this.props.sceneLostId || localStorage.getItem('sel_lots_id') || '';
        let params = {
            startDate,
            endDate,
            keyword: this.state.keyword || '',
            page: pageNumber,
            sceneCompanyId,
            sceneLostId,
        };

        if (perPage) {
            params.per_page = perPage;
        }

        let query = queryString.stringify(params);
        progressBar.start();

        return api.userLog.getUserLogs(query)
            .then(response => {
                this.setState({
                    ...this.state,
                    userLogList: response?.data?.data,
                });
                progressBar.done();
                return Promise.resolve(response?.data?.data);
            })
            .catch(() => {
                progressBar.done();
                return Promise.reject();
            });
    };

    handlePageChange = (pageNumber) => {
        this.getUserLogs(pageNumber);
    }

    exportUserLogs = () => {
        let startDate = this.state.startDate ? this.state.startDate.format('YYYY-MM-DD HH:mm:ss') : null;
        let endDate = this.state.endDate ? this.state.endDate.format('YYYY-MM-DD HH:mm:ss') : null;
        const sceneCompanyId = this.props.sceneCompanyId || localStorage.getItem('sel_company_id') || '';
        const sceneLostId = this.props.sceneLostId || localStorage.getItem('sel_lots_id') || '';
        let params = {
            startDate,
            endDate,
            keyword: this.state.keyword || '',
            sceneCompanyId,
            sceneLostId,
        };
        let query = queryString.stringify(params);

        progressBar.start();
        api.userLog.exportUserLogs(query).then((response) => {
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const contentDisposition = response.headers && response.headers['content-disposition']
                ? response.headers['content-disposition']
                : '';
            const matched = contentDisposition.match(/filename=\"?([^\";]+)\"?/);
            const fileName = matched && matched[1] ? matched[1] : 'user-log.csv';

            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            progressBar.done();
        }).catch(() => {
            progressBar.done();
        });
    }

    render() {
        const { userLogList } = this.state;

        return (
            <Fragment>
                <NotificationSystem ref={this.notificationSystem} allowHTML={this.state.notification.allowHTML} />

                <FormattedMessage id="dashboard.UserLog" defaultMessage="User Log">
                    {message => <Helmet><title>{message}</title></Helmet>}
                </FormattedMessage>

                <div className="main_top_bar static_bar">
                    <div className="box_sum_col_top">
                        <div className="box_left">
                            <ul className="nav nav_tabs">
                                <li className="nav_item">
                                    <span className="nav_link">
                                        <FormattedMessage id="dashboard.UserLog" defaultMessage="User Log" />
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <div className="box_center">
                            <div className="tabs_static_item">
                                <div className="main_control_time_select">
                                    <div className="filler_to_from">
                                        <div className="i_tem txt_form">
                                            <FormattedMessage id="dashboard.Period" defaultMessage="Period" />
                                        </div>

                                        <div className="i_tem box_control_input">
                                            <div className="box_control_date">
                                                <span className="icon_date" />
                                                <div className="date_picker_custom">
                                                    <DatePicker
                                                        dateFormat="YYYY/MM/DD"
                                                        selected={this.state.startDate}
                                                        selectsStart
                                                        className="from_date form_control form-control-sm unstyled"
                                                        startDate={this.state.startDate}
                                                        endDate={this.state.endDate}
                                                        onChange={this.changeStartDateHandler}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="i_tem txt_form hide">~</div>

                                        <div className="i_tem box_control_input">
                                            <div className="box_control_date">
                                                <span className="icon_date" />
                                                <div className="date_picker_custom">
                                                    <DatePicker
                                                        dateFormat="YYYY/MM/DD"
                                                        selected={this.state.endDate}
                                                        selectsStart
                                                        className="to_date form_control form-control-sm unstyled"
                                                        startDate={this.state.startDate}
                                                        endDate={this.state.endDate}
                                                        onChange={this.changeEndDateHandler}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="i_tem box_control_input">
                                            <div className="box_control_date">
                                                <input
                                                    type="text"
                                                    className="form_control"
                                                    value={this.state.keyword}
                                                    onChange={this.changeKeywordHandler}
                                                    placeholder={this.props.intl.formatMessage({ id: 'dashboard.SearchKeyword', defaultMessage: 'Search keyword' })}
                                                />
                                            </div>
                                        </div>

                                        <div className="i_tem box_control_input">
                                            <div className="box_control_date">
                                                <button className="btn btn_preference" onClick={() => this.getUserLogs(1)}>
                                                    <FormattedMessage id="dashboard.Search" defaultMessage="Search" />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="i_tem box_control_input">
                                            <div className="box_control_date">
                                                <button className="btn btn_preference" onClick={this.exportUserLogs}>
                                                    <FormattedMessage id="dashboard.Save" defaultMessage="Save" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="main_content">
                    <div className="content_tabs_main content_static_tabs tab-content">
                        <div className="tabs_static_item tabs_item1">
                            <div className="box_content_static">
                                <div className="left_col left_col_customer_care">
                                    <DataSetting location={this.props.location} />
                                </div>
                                <div className="content_col_nopading">
                                    <div className="list_control_box_preferences">
                                        <div className="content_left">
                                            <div className="content_column">
                                                <div className="column_box">
                                                    <div className="control_box_item">
                                                        <div className="card_body">
                                                            <div className="custom_table">
                                                                <table className="table st_table_5" style={{ textAlign: 'center' }}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th><FormattedMessage id="dashboard.Date" defaultMessage="Date" /></th>
                                                                            <th><FormattedMessage id="dashboard.Event" defaultMessage="Event" /></th>
                                                                            <th><FormattedMessage id="dashboard.Company" defaultMessage="Company" /></th>
                                                                            <th><FormattedMessage id="dashboard.AffiliatedCompany" defaultMessage="Affiliated Company" /></th>
                                                                            <th><FormattedMessage id="dashboard.userCode" defaultMessage="User Code" /></th>
                                                                            <th><FormattedMessage id="dashboard.Name" defaultMessage="Name" /></th>
                                                                            <th><FormattedMessage id="dashboard.IP" defaultMessage="IP" /></th>
                                                                            <th><FormattedMessage id="dashboard.Menu" defaultMessage="Menu" /></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {userLogList?.data?.length > 0 ? (
                                                                            userLogList.data.map((item) => {
                                                                                return (
                                                                                    <tr key={item.log_id}>
                                                                                        <td>{item.moved_at}</td>
                                                                                        <td>{item.event_type}</td>
                                                                                        <td>{item.company_name || item.company_id}</td>
                                                                                        <td>{item.lots_name || item.lots_id}</td>
                                                                                        <td>{item.usr_code}</td>
                                                                                        <td>{item.usr_name}</td>
                                                                                        <td>{item.login_ip}</td>
                                                                                        <td>{item.menu_name || item.menu_path}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan={8}>
                                                                                    <div className="nodata"><FormattedMessage id="dashboard.NoData" defaultMessage="No Data" /></div>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                        {userLogList?.data?.length > 0 && (
                                                            <div className="car_footer">
                                                                <nav aria-label="...">
                                                                    <ul className="custom_pagination pagination">
                                                                        <Pagination
                                                                            itemClass="page-item"
                                                                            linkClass="page-link"
                                                                            activePage={userLogList?.current_page}
                                                                            itemsCountPerPage={userLogList?.per_page}
                                                                            totalItemsCount={userLogList?.total}
                                                                            pageRangeDisplayed={10}
                                                                            onChange={this.handlePageChange}
                                                                        />
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        sceneCompanyId: state.sceneSelect.company_id,
        sceneLostId: state.sceneSelect.lots_id,
    }
};

export default injectIntl(connect(mapStateToProps)(UserLog));
